import { Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { KnowledgeItem } from '@/types/api'
import { downloadFileWithName } from '@/utils/download'
import type { CombinedColumnDef } from '@/api/dowload-excel.api'
import { formatDateTime } from '@/utils/format'

interface BuildColumnsOptions {
  pageIndex: number
  pageSize: number
  canDelete: boolean
  onDelete?: (item: KnowledgeItem) => void
}

export function buildColumns({
  pageIndex,
  pageSize,
  canDelete,
  onDelete,
}: BuildColumnsOptions): CombinedColumnDef<KnowledgeItem>[] {
  return [
    {
      id: 'stt',
      header: 'STT',
      size: 55,
      align: 'center',
      cell: ({ row }) => row.index + 1 + pageIndex * pageSize,
    },
    {
      accessorKey: 'name',
      header: 'TÊN TÀI LIỆU',
      align: 'left',
      cell: ({ row }) => {
        const item = row.original as any

        const handleDownload = async (url: string, fileName?: string) => {
          try {
            await downloadFileWithName({ url, fileName })
          } catch (error) {
            window.open(url, '_blank')
          }
        }

        return (
          <button
            type="button"
            className="cursor-pointer font-medium text-[#0088FF] underline hover:text-blue-700"
            onClick={() =>
              handleDownload(
                item.url || item.fileUrl || item.filePath || item.preview,
                item.name,
              )
            }
            title={item.name}
          >
            {item.name}
          </button>
        )
      },
    },
    {
      accessorKey: 'createdAt',
      header: 'NGÀY CẬP NHẬT',
      size: 130,
      align: 'center',
      cell: ({ getValue }) => formatDateTime(getValue()),
    },
    {
      id: 'actions',
      size: 55,
      align: 'center',
      exportable: false,
      cell: ({ row }) => (
        <div className="flex justify-center">
          {canDelete && (
            <Button
              variant="ghost"
              size="icon"
              className="hover:!bg-transparent hover:!text-[#CE7A58]"
              onClick={() => onDelete?.(row.original)}
            >
              <Trash2 size={18} />
            </Button>
          )}
        </div>
      ),
    },
  ]
}
